module.exports = __webpack_public_path__ + "static/media/badge-silver.4ca7b1ec.png";